"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = UploadArea;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const UploadControl_1 = __importDefault(require("../AppButton/UploadControl"));
const AppText_1 = require("../AppText");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const colors_1 = require("../../common/colors");
function UploadArea({ descriptionText, ...restProps }) {
    const triggerTextRef = (0, react_1.useRef)(null);
    const triggerButtonRef = (0, react_1.useRef)(null);
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const [isTextHovered, setIsTextHovered] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsx)(UploadControl_1.default, { dragAndDrop: true, triggerRef: [triggerTextRef, triggerButtonRef], ...restProps, children: (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.container, children: [(0, jsx_runtime_1.jsx)(react_native_1.Pressable, { ref: triggerButtonRef, onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false), style: [
                        styles.iconContainer,
                        isHovered && { backgroundColor: `${colors_1.Colors.PRIMARY_300}40` }
                    ], children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faCloudArrowUp, color: colors_1.Colors.PRIMARY_300, size: 20 }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: styles.textContainer, children: [(0, jsx_runtime_1.jsxs)(AppText_1.AppText, { style: styles.uploadText, children: ['Drag & drop or ', (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { ref: triggerTextRef, onHoverIn: () => setIsTextHovered(true), onHoverOut: () => setIsTextHovered(false), children: (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: [
                                            styles.triggerText,
                                            isTextHovered && { color: colors_1.Colors.PRIMARY_200 }
                                        ], children: "choose files" }) }), ' to upload'] }), (0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.descriptionText, children: descriptionText })] })] }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    container: {
        backgroundColor: '#1D2024',
        gap: 16,
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        paddingVertical: 42.5,
        borderColor: `${colors_1.Colors.PRIMARY_300}90`,
        borderWidth: 1,
        borderStyle: 'dashed',
        borderRadius: 8,
    },
    iconContainer: {
        width: 44,
        height: 44,
        borderRadius: 22,
        backgroundColor: `${colors_1.Colors.PRIMARY_300}20`,
        justifyContent: 'center',
        alignItems: 'center',
    },
    textContainer: {
        gap: 4,
        alignItems: 'center',
    },
    uploadText: {
        color: '#EFF1F1',
        fontSize: 16,
        lineHeight: 22.4,
    },
    triggerText: {
        color: colors_1.Colors.PRIMARY_300,
        textDecorationLine: 'underline',
    },
    descriptionText: {
        color: 'rgba(255, 255, 255, 0.40)',
        lineHeight: 19.6,
    }
});
